import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c691818"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "disconnect-container" }
const _hoisted_2 = ["data-network"]

import { CheckIcon } from '@heroicons/vue/20/solid';
import { useClaimStore } from '@/store/claimStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'DisconnectButton',
  setup(__props) {

const store = useClaimStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(CheckIcon), { class: "icon-complete" }),
    _createTextVNode(" " + _toDisplayString(_unref(store).ensOrFormattedWalletAddress) + " ", 1),
    _createElementVNode("div", {
      id: "giveaway-disconnect",
      "data-widget": "m-connect",
      "data-grant-type": "signature",
      "data-client-id": "02865a407876e82f4389f70992c25323e967504d37663290f11fd49e79b607e0",
      "data-app-name": "Manifold Notifications",
      "data-wallet-connect-project-id": "ca03bf2709bfa142a2d9adb0d6e99e7f",
      "data-enable-network-switching": true,
      "data-network": _unref(store).networkId,
      "data-browser-provider-ignore-disconnect": true,
      "data-multi": "true",
      "data-override-connect-text": "Connect wallet to get started",
      "data-message": "Please sign this message to use this Manifold Giveaway page and allow us to check for your eligibility."
    }, null, 8, _hoisted_2)
  ]))
}
}

})